module.exports = __webpack_public_path__ + "media/images/components/logo-boep-service-cbd8a86a12e71c1b81362b4a4527b276.png";